import { Context } from '@nuxt/types'
// import { AUTH_TOKEN_COOKIE_KEY } from '~/constants'

export default function ({ app, redirect }: Context) {
//   const authTokens = app.$cookies.get(AUTH_TOKEN_COOKIE_KEY)
//   if (authTokens) redirect('/')
  if (app.$auth.loggedIn) redirect(app.localePath('/'))
}
